import { useEffect, useState } from 'react';
import useAxiosWithAuth from '../api/useAxiosWithAuth';

const useImportLocationsQuery = () => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);

  const axiosInstance = useAxiosWithAuth();

  useEffect(() => {
    const fetchLocations = async () => {
      setLoading(true);

      try {
        const { data, status } = await axiosInstance.get('/trade/import-location?page_size=15000&page_number=1');

        if (status === 200) {
          const formatted = data.payload.map((location) => ({
            value: location.name,
            label: location.name,
          }));

          setLocations(formatted);
        } else {
          setLocations([]);
        }
      } catch (err) {
        console.error('Error fetching import locations:', err);
        setLocations([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLocations();
  }, []);

  return { locations, loading };
};

export default useImportLocationsQuery;
